import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconYourAccount from './nav-icon-your-account.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconYourAccount {...validProps} />;
}
SvgComponent.iconName = 'navIconYourAccount';

export const NavIconYourAccountIcon = svgIconWrapper(SvgComponent);
